export function Pencil() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5185_4684)">
        <path
          d="M10.5 3.74976L14.25 7.49976"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.75 14.9998L1.5 16.4998L3 11.2498L12.3105 1.93931C12.8962 1.35356 13.8458 1.35356 14.4315 1.93931L16.0605 3.56831C16.6462 4.15406 16.6462 5.10356 16.0605 5.68931L6.75 14.9998Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5185_4684">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
